import type { Key } from "react";

export function packageNameWithoutId(packageName: string) {
  return packageName.replace(/^[0-9]+[.]\s*/, "");
}

export function userFriendlyPackageId(pkg: {
  packageName: string;
  id: { id: string; userFriendlyId?: string | null };
}): Key {
  return pkg.id.userFriendlyId ?? pkg.packageName.replace(/^([0-9]+)[.]*.*/, "$1");
}
